//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'BaseCard',
	props: {
		actionsRight: {
			'type': Boolean,
			'default': false,
		},
		flat: {
			'type': Boolean,
			'default': true,
		},
	},
};
